import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { slug: String }

  dispatchHideEvent() {
    this.dispatch("hide", { detail: { slug: this.slugValue } })
  }
}
